module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Insurrection")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "title_page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/title_page"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#prologue"
    }
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#present-day"
    }
  }, [_vm._v("Present day")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#vicinity-of-hamidiyah-syria"
    }
  }, [_vm._v("Vicinity of Hamidiyah, Syria")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#chapter-1"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#himachal-pradesh-district-india"
    }
  }, [_vm._v("Himachal Pradesh district, India")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#chapter-2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#hammersmith-london"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#denver-colorado",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#hammersmith-london-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#denver-colorado-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hammersmith-london-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#quetta-pakistan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quetta, Pakistan")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#hammersmith-london-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#denver-colorado-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#hammersmith-london-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#denver-colorado-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#hammersmith-london-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#himachal-pradesh-district-india-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Himachal Pradesh district, India")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#raf-northolt-west-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Northolt, west London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#himachal-pradesh-district-india-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Himachal Pradesh district, India")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#c-130-hercules-call-sign-whisky-tango-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C-130 Hercules, call sign Whisky Tango 23")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#eastern-mediterranean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastern Mediterranean")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#quetta-pakistan-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quetta, Pakistan")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#raf-akrotiri-cyprus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Akrotiri, Cyprus")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#denver-colorado-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#raf-akrotiri-cyprus-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Akrotiri, Cyprus")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#quetta-pakistan-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quetta, Pakistan")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#denver-colorado-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#raf-akrotiri-cyprus-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAF Akrotiri, Cyprus")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#dakar-senegal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dakar, Senegal")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#new-delhi-india",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Delhi, India")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#denver-colorado-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#vicinity-of-homs-syria",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#denver-colorado-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#vicinity-of-homs-syria-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#new-york-new-york",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#vicinity-of-homs-syria-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#denver-colorado-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Denver, Colorado")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#vicinity-of-homs-syria-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#hammersmith-london-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#vicinity-of-homs-syria-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#savannah-georgia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savannah, Georgia")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#vicinity-of-homs-syria-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#j.-edgar-hoover-building-washington-dc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("J. Edgar Hoover Building, Washington, DC")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#vicinity-of-homs-syria-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicinity of Homs, Syria")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#chapter-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#savannah-georgia-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savannah, Georgia")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#chapter-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#hammersmith-london-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#chapter-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#in-transit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In transit")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#chapter-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#new-york-new-york-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#chapter-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#savannah-georgia-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savannah, Georgia")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#chapter-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#new-york-new-york-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#chapter-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#hammersmith-london-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hammersmith, London")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#chapter-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#new-york-new-york-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#chapter-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#eastern-seaboard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eastern seaboard")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#chapter-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#savannah-georgia-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savannah, Georgia")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#chapter-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#new-york-new-york-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#chapter-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#savannah-georgia-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Savannah, Georgia")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#chapter-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#boston-massachusetts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#chapter-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#new-york-new-york-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#chapter-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#boston-massachusetts-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#chapter-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#new-york-new-york-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New York, New York")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#chapter-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#boston-massachusetts-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#chapter-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#boston-massachusetts-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#chapter-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#boston-massachusetts-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#chapter-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#boston-massachusetts-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#chapter-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#outskirts-of-boston-massachusetts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outskirts of Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#chapter-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#boston-massachusetts-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#chapter-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#boston-massachusetts-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#chapter-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-130"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#boston-massachusetts-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-131"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#chapter-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-132"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#boston-massachusetts-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-133"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#chapter-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-134"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#boston-massachusetts-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-135"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#chapter-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 66")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#boston-massachusetts-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-137"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#chapter-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 67")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-138"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#boston-massachusetts-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boston, Massachusetts")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-139"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#chapter-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 68")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-140"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#islamabad-islamic-republic-of-pakistan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Islamabad, Islamic Republic of Pakistan")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-141"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s note")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-142"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#isis-and-daesh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ISIS and Daesh")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-143"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#the-doughnut-echelon-and-the-web-based-email-loophole",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Doughnut, Echelon and the web-based email loophole")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-144"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#bhopal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bhopal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-145"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#satellite-surveillance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Satellite surveillance")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-146"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#an-agent-paul-richter-thriller",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Agent Paul Richter Thriller")])]), _vm._v(" "), _c('li', {
    staticClass: "author_bio"
  }, [_c('span', {
    attrs: {
      "href": "#/text/author_bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    staticClass: "also_by"
  }, [_c('span', {
    attrs: {
      "href": "#/text/also_by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by James Barrington")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-147"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/nav#toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/title_page"
    }
  }, [_vm._v("Start of Content")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-246b895e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 57
// module chunks = 0